"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var RadioActive = function RadioActive(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "RadioActive"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "radio-active"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 1.42c4.739 0 8.58 3.841 8.58 8.58s-3.841 8.58-8.58 8.58c-4.739 0-8.58-3.841-8.58-8.58v0c0-4.739 3.841-8.58 8.58-8.58v0M10 0c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM10 4.28c-3.159 0-5.72 2.561-5.72 5.72s2.561 5.72 5.72 5.72c3.159 0 5.72-2.561 5.72-5.72v0c0-3.159-2.561-5.72-5.72-5.72v0z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = RadioActive;
exports["default"] = _default;